import React from "react";
import "../../begin-questionnaire/begin-questionnaire.css";

export const Renderresponsiveoptionnames = (props) => {
  if (!props || !props.instrumentOptions || props.instrumentOptions.length === 0) {
  
    return null;
  }

  const getDefaultTextColor = () => {
    if (props.touched) {
      return "#30c535";
    }
    return "#aaaaaa";
  };

  const reverseInstrumentOptions = () => {
    const newInstrumentOptions = [...props.instrumentOptions];
    return newInstrumentOptions.reverse();
  };

  const getMaxValue = () => {
    if (!props.instrumentOptions || props.instrumentOptions.length === 0) {
      return 5;
    }
    const maxOption = props.instrumentOptions[props.instrumentOptions.length - 1];
    return maxOption.option_end_value;
  };



  return (
    <div
      className="option-name-wrapper option-name-wrapper-responsive"
 
    >
      <ul>
        {(props.questionList && props.questionList.answer_type
          ? props.instrumentOptions
          : reverseInstrumentOptions()
        ).map((getOptionName) => {
          const maxValue = getMaxValue();
          let shouldHighlight = false;
          let mainValue = props.value;

          if (props.questionList && !props.questionList.answer_type) {
            if (maxValue === 5) {
              const transformedValue = 5 - props.value;
           

              shouldHighlight = 
                transformedValue >= getOptionName.option_start_value && 
                transformedValue <= getOptionName.option_end_value;
            } else if (maxValue === 10) {
              const transformedValue = 10 - props.value;
          

              shouldHighlight = 
                transformedValue >= getOptionName.option_start_value && 
                transformedValue <= getOptionName.option_end_value;
            }
          } else {
            // For answer_type true (both max values)
          

            shouldHighlight = 
              mainValue >= getOptionName.option_start_value && 
              mainValue <= getOptionName.option_end_value;
          }

          const getFlexValue = getOptionName.option_end_value - getOptionName.option_start_value;

          return (
            <li
              key={getOptionName.option_name}
              style={{
                flex: getFlexValue,
                color: shouldHighlight ? getDefaultTextColor() : "",
                paddingBottom: props.instrumentType === "VVI" ? "85px" : "35px",
              }}
            >
              {getOptionName.option_name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/responsive/responsive-option-names.jsx